import React, { useState } from 'react';
import { EditIcon, SaveIcon, XIcon, StethoscopeIcon, AwardIcon, DollarSignIcon, ClockIcon, VideoIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
interface DoctorProfileProps {
  doctorId: number;
}
export function DoctorProfile({
  doctorId
}: DoctorProfileProps) {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: 'Dr. Sarah Johnson',
    specialization: 'Cardiologist',
    qualification: 'MD, FACC',
    experience: '15 years',
    registrationNumber: 'MCI12345',
    email: 'sarah.johnson@clinic.com',
    phone: '+1 (555) 123-4567',
    consultationFee: '150',
    followUpFee: '100',
    teleconsultationLink: 'https://meet.google.com/abc-defg-hij',
    languages: 'English, Spanish, French',
    about: 'Experienced cardiologist specializing in interventional cardiology and heart disease prevention.'
  });
  const [clinicTimings, setClinicTimings] = useState([{
    day: 'Monday',
    startTime: '09:00',
    endTime: '17:00',
    location: 'Main Clinic',
    enabled: true
  }, {
    day: 'Tuesday',
    startTime: '09:00',
    endTime: '17:00',
    location: 'Main Clinic',
    enabled: true
  }, {
    day: 'Wednesday',
    startTime: '09:00',
    endTime: '13:00',
    location: 'North Branch',
    enabled: true
  }, {
    day: 'Thursday',
    startTime: '09:00',
    endTime: '17:00',
    location: 'Main Clinic',
    enabled: true
  }, {
    day: 'Friday',
    startTime: '09:00',
    endTime: '17:00',
    location: 'Main Clinic',
    enabled: true
  }, {
    day: 'Saturday',
    startTime: '09:00',
    endTime: '13:00',
    location: 'Main Clinic',
    enabled: true
  }, {
    day: 'Sunday',
    startTime: '',
    endTime: '',
    location: '',
    enabled: false
  }]);
  const [locations, setLocations] = useState([{
    id: 1,
    name: 'Main Clinic',
    address: '123 Medical Center Dr, New York, NY 10001',
    phone: '+1 (555) 100-0001'
  }, {
    id: 2,
    name: 'North Branch',
    address: '456 Healthcare Ave, New York, NY 10002',
    phone: '+1 (555) 100-0002'
  }]);
  const handleSave = () => {
    setIsEditing(false);
    alert('Doctor profile updated successfully!');
  };
  return <div className="space-y-6" data-id="element-424">
      {/* Header with Edit Button */}
      <div className="flex items-center justify-between" data-id="element-425">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-426">Doctor Profile</h2>
        {!isEditing ? <button onClick={() => setIsEditing(true)} className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700" data-id="element-427">
            <EditIcon className="w-4 h-4" data-id="element-428" />
            <span data-id="element-429">Edit Profile</span>
          </button> : <div className="flex space-x-2" data-id="element-430">
            <button onClick={() => setIsEditing(false)} className="flex items-center space-x-2 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" data-id="element-431">
              <XIcon className="w-4 h-4" data-id="element-432" />
              <span data-id="element-433">Cancel</span>
            </button>
            <button onClick={handleSave} className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700" data-id="element-434">
              <SaveIcon className="w-4 h-4" data-id="element-435" />
              <span data-id="element-436">Save</span>
            </button>
          </div>}
      </div>
      {/* Basic Information */}
      <div className="border border-gray-200 rounded-lg p-6" data-id="element-437">
        <h3 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4" data-id="element-438">
          <StethoscopeIcon className="w-5 h-5 text-purple-600" data-id="element-439" />
          <span data-id="element-440">Basic Information</span>
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-441">
          <div data-id="element-442">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-443">
              Full Name
            </label>
            <input type="text" value={formData.name} onChange={e => setFormData({
            ...formData,
            name: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-444" />
          </div>
          <div data-id="element-445">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-446">
              Specialization
            </label>
            <input type="text" value={formData.specialization} onChange={e => setFormData({
            ...formData,
            specialization: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-447" />
          </div>
          <div data-id="element-448">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-449">
              Qualification
            </label>
            <input type="text" value={formData.qualification} onChange={e => setFormData({
            ...formData,
            qualification: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-450" />
          </div>
          <div data-id="element-451">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-452">
              Experience
            </label>
            <input type="text" value={formData.experience} onChange={e => setFormData({
            ...formData,
            experience: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-453" />
          </div>
          <div data-id="element-454">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-455">
              Registration Number
            </label>
            <input type="text" value={formData.registrationNumber} onChange={e => setFormData({
            ...formData,
            registrationNumber: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-456" />
          </div>
          <div data-id="element-457">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-458">
              Languages
            </label>
            <input type="text" value={formData.languages} onChange={e => setFormData({
            ...formData,
            languages: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-459" />
          </div>
          <div className="md:col-span-2" data-id="element-460">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-461">
              About
            </label>
            <textarea value={formData.about} onChange={e => setFormData({
            ...formData,
            about: e.target.value
          })} disabled={!isEditing} rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-462" />
          </div>
        </div>
      </div>
      {/* Contact Information */}
      <div className="border border-gray-200 rounded-lg p-6" data-id="element-463">
        <h3 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4" data-id="element-464">
          <PhoneIcon className="w-5 h-5 text-purple-600" data-id="element-465" />
          <span data-id="element-466">Contact Information</span>
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-467">
          <div data-id="element-468">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-469">
              Email
            </label>
            <input type="email" value={formData.email} onChange={e => setFormData({
            ...formData,
            email: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-470" />
          </div>
          <div data-id="element-471">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-472">
              Phone
            </label>
            <input type="tel" value={formData.phone} onChange={e => setFormData({
            ...formData,
            phone: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-473" />
          </div>
        </div>
      </div>
      {/* Consultation Fees */}
      <div className="border border-gray-200 rounded-lg p-6" data-id="element-474">
        <h3 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4" data-id="element-475">
          <DollarSignIcon className="w-5 h-5 text-purple-600" data-id="element-476" />
          <span data-id="element-477">Consultation Fees</span>
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-478">
          <div data-id="element-479">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-480">
              First Consultation Fee ($)
            </label>
            <input type="number" value={formData.consultationFee} onChange={e => setFormData({
            ...formData,
            consultationFee: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-481" />
          </div>
          <div data-id="element-482">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-483">
              Follow-up Fee ($)
            </label>
            <input type="number" value={formData.followUpFee} onChange={e => setFormData({
            ...formData,
            followUpFee: e.target.value
          })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-484" />
          </div>
        </div>
      </div>
      {/* Teleconsultation */}
      <div className="border border-gray-200 rounded-lg p-6" data-id="element-485">
        <h3 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4" data-id="element-486">
          <VideoIcon className="w-5 h-5 text-purple-600" data-id="element-487" />
          <span data-id="element-488">Teleconsultation</span>
        </h3>
        <div data-id="element-489">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-490">
            Teleconsultation Link (Google Meet / Zoom)
          </label>
          <input type="url" value={formData.teleconsultationLink} onChange={e => setFormData({
          ...formData,
          teleconsultationLink: e.target.value
        })} disabled={!isEditing} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" placeholder="https://meet.google.com/your-meeting-link" data-id="element-491" />
        </div>
      </div>
      {/* Clinic Timings */}
      <div className="border border-gray-200 rounded-lg p-6" data-id="element-492">
        <h3 className="flex items-center space-x-2 text-lg font-semibold text-gray-900 mb-4" data-id="element-493">
          <ClockIcon className="w-5 h-5 text-purple-600" data-id="element-494" />
          <span data-id="element-495">Clinic Timings</span>
        </h3>
        <div className="space-y-3" data-id="element-496">
          {clinicTimings.map((timing, index) => <div key={timing.day} className="grid grid-cols-1 md:grid-cols-5 gap-3 items-center p-3 border border-gray-200 rounded-lg" data-id="element-497">
              <div className="font-medium text-gray-900" data-id="element-498">{timing.day}</div>
              <input type="time" value={timing.startTime} onChange={e => {
            const newTimings = [...clinicTimings];
            newTimings[index].startTime = e.target.value;
            setClinicTimings(newTimings);
          }} disabled={!isEditing || !timing.enabled} className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-499" />
              <input type="time" value={timing.endTime} onChange={e => {
            const newTimings = [...clinicTimings];
            newTimings[index].endTime = e.target.value;
            setClinicTimings(newTimings);
          }} disabled={!isEditing || !timing.enabled} className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-500" />
              <select value={timing.location} onChange={e => {
            const newTimings = [...clinicTimings];
            newTimings[index].location = e.target.value;
            setClinicTimings(newTimings);
          }} disabled={!isEditing || !timing.enabled} className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent disabled:bg-gray-50" data-id="element-501">
                <option value="" data-id="element-502">Select Location</option>
                {locations.map(loc => <option key={loc.id} value={loc.name} data-id="element-503">
                    {loc.name}
                  </option>)}
              </select>
              <label className="flex items-center space-x-2" data-id="element-504">
                <input type="checkbox" checked={timing.enabled} onChange={e => {
              const newTimings = [...clinicTimings];
              newTimings[index].enabled = e.target.checked;
              setClinicTimings(newTimings);
            }} disabled={!isEditing} className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500" data-id="element-505" />
                <span className="text-sm text-gray-700" data-id="element-506">Available</span>
              </label>
            </div>)}
        </div>
      </div>
      {/* Multi-Location Support */}
      <div className="border border-gray-200 rounded-lg p-6" data-id="element-507">
        <div className="flex items-center justify-between mb-4" data-id="element-508">
          <h3 className="flex items-center space-x-2 text-lg font-semibold text-gray-900" data-id="element-509">
            <MapPinIcon className="w-5 h-5 text-purple-600" data-id="element-510" />
            <span data-id="element-511">Practice Locations</span>
          </h3>
          {isEditing && <button className="px-3 py-1 text-sm bg-purple-600 text-white rounded-lg hover:bg-purple-700" data-id="element-512">
              Add Location
            </button>}
        </div>
        <div className="space-y-3" data-id="element-513">
          {locations.map(location => <div key={location.id} className="p-4 border border-gray-200 rounded-lg" data-id="element-514">
              <div className="flex items-start justify-between" data-id="element-515">
                <div className="flex-1" data-id="element-516">
                  <h4 className="font-semibold text-gray-900 mb-1" data-id="element-517">
                    {location.name}
                  </h4>
                  <p className="text-sm text-gray-600 mb-1" data-id="element-518">
                    {location.address}
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-519">
                    Phone: {location.phone}
                  </p>
                </div>
                {isEditing && <button className="text-red-600 hover:text-red-700 text-sm" data-id="element-520">
                    Remove
                  </button>}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}